module.exports = __webpack_public_path__ + "img/hyc_logo.55361fa6.png";